import { shape, arrayOf } from 'prop-types';
import shipmentStopShape from './shipment-stop';

const shipmentInformationShape = shape({
  origin: shipmentStopShape,
  inBetweenStops: arrayOf(shipmentStopShape),
  destination: shipmentStopShape,
});

export default shipmentInformationShape;
